import {
  DEFAULT_NSW_ACT_SCHOOL_TYPE,
  DEFAULT_ORDER_REGION,
  NSW_ACT_SCHOOL_TYPES,
  ORDER_REGIONS,
  type NswActSchoolType,
  type OrderRegion,
} from "./products";

/** Own sessionStorage key, beside the cart's `smartered-cart`. */
export const REGION_STORAGE_KEY = "smartered-order-region";

export interface RegionChoice {
  region: OrderRegion;
  schoolType: NswActSchoolType;
}

export const DEFAULT_REGION_CHOICE: RegionChoice = {
  region: DEFAULT_ORDER_REGION,
  schoolType: DEFAULT_NSW_ACT_SCHOOL_TYPE,
};

/**
 * Restore the direct order page's region choice so returning from /checkout (or a
 * reload) shows the view that holds the cart's products. Anything absent or
 * unrecognised falls back, field by field, to NSW & ACT / non-government.
 */
export function loadRegionChoice(): RegionChoice {
  try {
    const stored = sessionStorage.getItem(REGION_STORAGE_KEY);
    if (!stored) return DEFAULT_REGION_CHOICE;

    const parsed = JSON.parse(stored) as Partial<Record<keyof RegionChoice, unknown>> | null;
    const region = ORDER_REGIONS.find((r) => r === parsed?.region) ?? DEFAULT_ORDER_REGION;
    const schoolType = NSW_ACT_SCHOOL_TYPES.find((t) => t === parsed?.schoolType) ?? DEFAULT_NSW_ACT_SCHOOL_TYPE;
    return { region, schoolType };
  } catch {
    return DEFAULT_REGION_CHOICE;
  }
}

export function saveRegionChoice(choice: RegionChoice): void {
  try {
    sessionStorage.setItem(REGION_STORAGE_KEY, JSON.stringify(choice));
  } catch {
    // Ignore storage errors
  }
}
